import { useDispatch, useSelector } from 'react-redux'

import { actions } from './slice'
import { StorageType } from '../../../../features/storages/types'
import { storageSearchQuerySelector, visibleStorageTypesSelector } from './selectors'

export function useVisibleStorageTypes(): StorageType[] {
  return useSelector(visibleStorageTypesSelector)
}

export function useSetStorageSearch(): (query: string) => void {
  const dispatch = useDispatch()
  return query => dispatch(actions.setSearchQuery(query))
}

export function useStorageSearchQuery(): string {
  return useSelector(storageSearchQuerySelector)
}
